<template>
  <CycleSelection />
</template>

<script>
import CycleSelection from "@/components/CycleSelection/index.vue";
export default {
  components: {
    CycleSelection,
  },
};
</script>

<style></style>
